
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import type { Field } from '@/shared/types/aperTemplate';
import type { ResponseDTO } from '@/shared/apis/aper/aperEvaluations';

@Component
export default class NumberFieldResponse extends Vue {
  @Prop({ type: Object, required: true }) readonly field!: Field;
  @Prop({ type: Object, required: false }) readonly response?: ResponseDTO;
  @Prop({ type: Boolean, required: false }) readonly  disabled?: boolean

  localResponse: ResponseDTO = {
    fieldId: 0,
    numericValue: undefined,
    comment: ''
  };

  created() {
    this.initializeResponse();
  }
 
  @Watch('response')
  onResponseChange() {
    this.initializeResponse();
  }

  initializeResponse() {
    if (this.response) {
      this.localResponse = { ...this.response };
    } else {
      this.localResponse = {
        fieldId: this.field.id || 0,
        numericValue: undefined,
        comment: ''
      };
    }
  }

  getValidationRules() {
    const rules: Array<(v: number | null) => string | boolean> = [];

    if (this.field.required) {
      rules.push((v: number | null) => v !== null && v !== undefined || `${this.field.label} is required`);
    }

    if (this.field.minValue !== undefined) {
      rules.push(
        (v: number | null) =>
          v === null ||
          v === undefined ||
          v >= this.field.minValue! ||
          `Must be at least ${this.field.minValue}`
      );
    }

    if (this.field.maxValue !== undefined) {
      rules.push(
        (v: number | null) =>
          v === null ||
          v === undefined ||
          v <= this.field.maxValue! ||
          `Must be at most ${this.field.maxValue}`
      );
    }

    return rules;
  }

  updateResponse() {
    this.$emit('update:response', this.localResponse);
  }
}
